export default __webpack_public_path__ + "static/media/icon-algohealth-n@3x.5422c58b.webp";